import styled from 'styled-components';

import { EmptyState } from '@components/empty-state';
import { IconStop } from '@components/icons/stop';
import { useScopedTranslate } from '@locale/translate';

export const FormClosed = ({
  closedHeading,
  closedMessage,
  closeReason,
}: {
  closedHeading?: string | null;
  closedMessage?: string | null;
  closeReason?: 'deadline_passed' | 'response_limit_reached' | null;
}) => {
  const { t } = useScopedTranslate(translations);

  const getDefaultContent = () => {
    if (closeReason === 'deadline_passed') {
      return {
        heading: t('deadlineHeading'),
        message: t('deadlineMessage'),
      };
    }
    if (closeReason === 'response_limit_reached') {
      return {
        heading: t('limitHeading'),
        message: t('limitMessage'),
      };
    }
    return {
      heading: t('defaultHeading'),
      message: t('defaultMessage'),
    };
  };

  const defaultContent = getDefaultContent();

  return (
    <Wrapper>
      <EmptyState
        icon={<IconStop />}
        header={closedHeading || defaultContent.heading}
        content={closedMessage || defaultContent.message}
        orientation="horizontal"
        transparent
        skipMargin
      />
    </Wrapper>
  );
};

const translations = {
  en: {
    defaultHeading: 'This form is now closed',
    defaultMessage: 'This form is no longer accepting submissions.',
    deadlineHeading: 'This form is now closed',
    deadlineMessage:
      'This form was available for a limited time, and the submission deadline has now passed.',
    limitHeading: 'Responses are full',
    limitMessage:
      'This form has reached its submission limit and can no longer accept new responses.',
  },
};

const Wrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  padding: '4rem 2rem',
});
